import { type InputHTMLAttributes, type ReactNode, type Ref } from 'react';
import { inputClass } from '@/shared/utils/styles';
import PasswordInput from './PasswordInput';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  id: string;
  ref?: Ref<HTMLInputElement>;
  suffix?: ReactNode;
  hasError?: boolean;
  density?: 'comfortable' | 'dense';
}

export default function FormInput({
  ref,
  id,
  suffix,
  hasError = false,
  disabled,
  type = 'text',
  density,
  ...inputProps
}: Props) {
  if (type === 'password') {
    return <PasswordInput ref={ref} id={id} hasError={hasError} disabled={disabled} {...inputProps} />;
  }

  const base = inputClass(hasError, disabled, density);
  const padded = suffix ? 'pr-16' : '';

  if (suffix) {
    return (
      <div className="relative w-full">
        <input ref={ref} id={id} name={id} type={type} disabled={disabled} className={`${base} ${padded}`} {...inputProps} />
        <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-xs font-semibold uppercase text-slate-400">
          {suffix}
        </span>
      </div>
    );
  }

  return <input ref={ref} id={id} name={id} type={type} disabled={disabled} className={base} {...inputProps} />;
}
